import delay from 'lodash/delay'

const debugLog = (message: string, color: string) => {
  if (process.env.NEXT_PUBLIC_DEBUG_ANALYTICS === '1') {
    console.log(`%c${message}`, color)
  }
}

const poll = (
  condition: () => boolean,
  callback: () => void,
  { maxWait = 3000, interval = 100 } = {}
) => {
  const startTime = Date.now()
  let checkCount = 0

  debugLog(
    `[poll] Starting poll with maxWait: ${maxWait}ms, interval: ${interval}ms`,
    'color: #2563eb; font-weight: bold'
  )

  const check = () => {
    checkCount++
    const elapsed = Date.now() - startTime
    const conditionResult = condition()

    debugLog(
      `[poll] Check #${checkCount} - elapsed: ${elapsed}ms, condition: ${conditionResult}`,
      'color: #6b7280'
    )

    if (conditionResult) {
      debugLog(
        `[poll] ✓ Condition met after ${elapsed}ms (${checkCount} checks) - executing callback`,
        'color: #059669; font-weight: bold'
      )
      callback()
    } else if (elapsed < maxWait) {
      debugLog(
        `[poll] ⏳ Condition not met, scheduling next check in ${interval}ms`,
        'color: #d97706'
      )
      delay(check, interval)
    } else {
      debugLog(
        `[poll] ⏱️ Timeout after ${elapsed}ms (${checkCount} checks) - executing fallback callback`,
        'color: #dc2626; font-weight: bold'
      )
      callback() // Fallback
    }
  }

  check()
}

export default poll
